
import { Vue, Options } from 'vue-class-component'
let instanceCounter = 0
@Options({ name: 'Key1', props: { width: { type: [Number, String], default: 56 }, height: { type: [Number, String], default: 40 } } })
export default class Key1 extends Vue {
  private instanceId = `key1-${++instanceCounter}`
  get glossId(): string { return `${this.instanceId}-gloss` }
  get highlightId(): string { return `${this.instanceId}-highlight` }
}
